module.exports = __webpack_public_path__ + "static/media/fondo_musico.7e346fa0.jpg";